<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">User Management</h3>
      </div>
    </div>

      <d-row>
      <d-col><p align="right"><d-button outline v-on:click="redirectUser()">Add User</d-button></p></d-col>
      </d-row>

    <d-modal v-if="showModal" @close="handleClose">
        <d-modal-header>
            <d-modal-title>User form</d-modal-title>
        </d-modal-header>
        <d-modal-body>
        <d-form>
          <d-form-row>
            <!-- First Name -->
            <d-col md="6" class="form-group">
              <label for="feFirstName">First Name</label>
              <d-form-input
                type="text"
                id="feFirstName"
                placeholder="First Name"
                v-model="users.firstName"
              />
            </d-col>

            <!-- Last Name -->
            <d-col md="6" class="form-group">
              <label for="feLastName">Last Name</label>
              <d-form-input
                type="text"
                id="feLastName"
                placeholder="Last Name"
                v-model="users.lastName"
              />
            </d-col>
          </d-form-row>

          <div class="form-group">
            <label>Gender: </label>
            <d-form-select v-model="users.gender" :options="options" />
          </div>

          <div class="form-group">
            <label>Email: </label>
            <d-input id="email" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Email" v-model="users.email" readonly/>
          </div>
        
          <div class="form-group">
            <label>Phone: </label>
            <d-input id="phone" class="mb-2 mr-sm-2 mb-sm-0" placeholder="Phone" v-model="users.phone" />
          </div>

            <d-button theme="primary" @click.prevent="updateStaff()">Update</d-button>
        </d-form>
        </d-modal-body>
    </d-modal>  

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">List of Public User</h6>
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">User Id</th>
                  <th scope="col" class="border-0">Email</th>
                  <th scope="col" class="border-0">Status</th>
                  <th scope="col" class="border-0">Action</th>
                </tr>
              </thead>
                <tbody>
                    <tr v-for="result in user" :key="result.id">
                        <td>{{result.userId}}</td>
                        <td>{{result.email}}</td>
                        <td>
                          <i v-if="result.suspended" class="material-icons mr-1">highlight_off</i>
                          <i v-else class="material-icons mr-1">check_circle_outline</i>
                        </td>
                        <td>
                        <d-button-group size="small">
                        <d-button @click.native="handleClick" @click="edit(result.userId)"><i class="material-icons">edit</i></d-button>      
                        <d-button theme="danger" v-on:click="deleteData(result.userId)"><i class="material-icons">delete</i></d-button>
                        </d-button-group>
                        </td>
                    </tr>                    
                </tbody>             
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
          user: [],
          userId: "",
          users: {},
          showModal: false,
          options: [
            { value: 'Male', text: 'Male' },
            { value: 'Female', text: 'Female' },
          ]
        }
    },
    mounted: function () {
      axios
        .get(process.env.VUE_APP_SERVICE_URL+'api/admin/User/public_user')
        .then(response => {
          this.user = response.data.result.result;
          //console.log(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    methods: {
        redirectUser() {
          // this method is called on button click
          if (1 == 1) {
            this.$router.push({ name: "create-user" });
          }
        },
        handleClick() {
            this.showModal = true
        },
        handleClose() {
            this.showModal = false
        },
        deleteData(id) {
          axios.delete(process.env.VUE_APP_SERVICE_URL+`api/admin/User/${id}/true`
          )
          .then();
        },
        edit(id) {
          this.userId = id;
            axios
              .get(process.env.VUE_APP_API+'api/staff/Profile/' + id)
              .then(response => {
                this.users = response.data.result;
                //console.log(response.data);
              })
        },
        updateStaff() {
          axios
            .put(process.env.VUE_APP_API+"api/staff/Profile/" + this.userId,{
                firstname: this.users.firstName,
                lastname: this.users.lastName,
                gender: this.users.gender,
                phone: this.users.phone,
              }
            )
            .then((response) => {
              //console.log(response.data);
            })
        },
    }
};
</script>